<template>
  <ul class="nav-menu-links" ref="menuLinks" data-animate="menu-links">
    <!-- Prodotti -->
    <li v-for="link in links" :key="link.key" :class="link.class">
      <!-- Link -->
      <NuxtLink
        v-if="link.route"
        class="nav-menu-link link-menu-1"
        :to="localePath(link.route)"
        data-animate="menu-link"
        ><span>{{
          link.title ? link.title : $t(`navigation.${link.key}`)
        }}</span></NuxtLink
      >
      <!-- Links Back -->
      <button
        v-else-if="link.search"
        class="link-menu-1"
        @click="openSearch"
        data-animate="menu-link"
      >
        <span>{{ $t(`navigation.search`) }}</span>
      </button>

      <!-- Links Back -->
      <button
        v-else-if="link.back"
        class="link-menu-1 --ico-back"
        @click="openSubmenu(link.action)"
        data-animate="menu-link"
      >
        <img
          src="~/assets/img/ico/ico-nav-arrow-back.svg"
          alt="Ico nav arrow back"
          width="16"
          height="19"
        />
        <span>{{ $t(`navigation.${link.key}`) }}</span>
      </button>
      <!-- Links Forward -->
      <button
        v-else
        class="link-menu-1"
        @click="openSubmenu(link.action)"
        data-animate="menu-link"
      >
        <span>{{ link.title || $t(`navigation.${link.key}`) }}</span>
        <img
          src="~/assets/img/ico/ico-nav-arrow-forward.svg"
          alt="Ico nav arrow forward"
          width="16"
          height="19"
        />
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'NavigationMenuLinks',
}
</script>

<script setup>
import { gsap } from 'gsap'

const emit = defineEmits(['open-sub-menu', 'open-search'])

const props = defineProps({
  show: Boolean,
  links: Array,
})

const menuLinks = ref(null)
const tl = ref(null)

const openSubmenu = (action) => emit('open-sub-menu', action)
const openSearch = () => emit('open-search')

watch(
  () => props.show,
  (show) => {
    if (!tl.value?.isActive()) {
      tl.value = show ? animateIn() : animateOut()
      tl.value.duration(0.5).play()
    }
  }
)

// Animazioni
const animateIn = (params) => {
  const parent = menuLinks.value
  const links = parent.querySelectorAll('[data-animate="menu-link"]')

  const tl = gsap.timeline({
    paused: true,
    onComplete: () => {
      tl.kill()
    },
    ...params,
  })
  tl.set(parent, { autoAlpha: 1, position: 'relative' })
  tl.to(links, {
    y: '0%',
    stagger: 0.05,
    opacity: 1,
  })

  return tl
}

const animateOut = (params) => {
  const parent = menuLinks.value
  const links = parent.querySelectorAll('[data-animate="menu-link"]')

  const tl = gsap.timeline({
    paused: true,
    onStart: () => {
      gsap.set(parent, { position: 'absolute' })
    },
    onComplete: () => {
      tl.kill()
      gsap.set([parent, links], {
        clearProps: 'all',
      })
    },
    ...params,
  })
  tl.to(links, {
    y: '101%',
    opacity: 0,
    stagger: 0.05,
  })
  tl.set(parent, { autoAlpha: 0 })

  return tl
}

defineExpose({
  animateIn,
  animateOut,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
